import React from 'react'
import Donation from './Donation'

const DonationList = ({ donations, handleChange, paymentIntentId }) => {
  return (
    <div>
      <h4>Voluntary Contributions:</h4>
      {donations.map(({ label, value, fund }, index) => {
        return (
          <Donation
            index={index}
            key={fund}
            label={label}
            value={value}
            fund={fund}
            handleChange={handleChange}
          />
        )
      })}
    </div>
  )
}

export default DonationList
